<label class="checkbox-wrapper m-0">
  <app-text class="text-c300 checkBtn-label">{{ locale?.checkBox.donotShow }}</app-text>
  <input #checkButtton id="checkButton" type="checkbox" [checked]="isChecked" (change)="onChangeCheckbox(isChecked)">
  <span class="d-flex justify-content-center align-items-center checkmark">
    <span class="icon-wrap">
      <app-image [src]="'/assets/image/right_tick.svg'" [width]="'8px'" [height]="'8px'"></app-image>
    </span>
  </span>
</label>
